import {
  faBan,
  faBurgerSoda,
  faCalendarClock,
  faCalendarDay,
  faClipboardCheck,
  faDoorOpen,
  faHeadSideMedical,
  faHeart,
  faHospital,
  faHouse,
  faIdBadge,
  faLightbulbExclamationOn,
  faParkingCircle,
  faScalpel,
  faShieldCheck,
  faStarOfLife,
  faSyringe,
  faTShirt,
  faWindow,
  faCalendar as lightCalendar,
  faCalendarCheck as lightCalendarCheck,
  faClock as lightClock,
  faInfoCircle as lightInfoCircle,
  faLocationDot as lightLocationDot,
  faPhone as lightPhone,
  faBriefcaseMedical
} from '@medely/pro-light-svg-icons';
import {
  faArrowDownToLine,
  faArrowUpFromBracket,
  faAward,
  faCalendar,
  faCalendarCheck,
  faCamera,
  faChartLine,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleDollarToSlot,
  faClock,
  faCreditCard,
  faEdit,
  faEllipsisVertical,
  faExclamationTriangle,
  faEye,
  faFilePlus,
  faGear,
  faInfoCircle,
  faLandmark,
  faListCheck,
  faLocationCrosshairs,
  faLocationDot,
  faMobile,
  faPaperPlane,
  faPhone,
  faPlane,
  faPlus,
  faSearch,
  faSparkles,
  faTrashAlt,
  faUser,
  faUserMagnifyingGlass,
  faXmark,
} from '@medely/pro-regular-svg-icons';
import {
  faCaretDown,
  faCaretUp,
  faCircleExclamation,
  faCircleInfo as faCircleInfoSolid,
  faHeart as faHeartSolid,
  faMountains,
} from '@medely/pro-solid-svg-icons';
import React from 'react';
import type { IconName, IconProps } from './interface';
import { InternalIcon, type IconDefinition } from './InternalIcon';

// To better organize the icons, add the regular ones with just the name,
// the solid ones with solid in front and the light ones following the same pattern
// ex. calendar | solid-calendar | light-calendar
const ICON_MAP: Record<IconName, IconDefinition> = {
  // regular
  'arrow-up-from-bracket': faArrowUpFromBracket,
  award: faAward,
  calendar: faCalendar,
  'calendar-check': faCalendarCheck,
  check: faCheck,
  'chevron-down': faChevronDown,
  'chevron-left': faChevronLeft,
  'chevron-right': faChevronRight,
  'chevron-up': faChevronUp,
  'circle-dollar-to-slot': faCircleDollarToSlot,
  'circle-check': faCircleCheck,
  camera: faCamera,
  'chart-line': faChartLine,
  clock: faClock,
  edit: faEdit,
  'ellipsis-vertical': faEllipsisVertical,
  'exclamation-triangle': faExclamationTriangle,
  'eye-regular': faEye,
  gear: faGear,
  heart: faHeart,
  'info-circle': faInfoCircle,
  'list-check': faListCheck,
  'location-crosshairs': faLocationCrosshairs,
  plus: faPlus,
  search: faSearch,
  sparkles: faSparkles,
  'credit-card': faCreditCard,
  landmark: faLandmark,
  'location-dot': faLocationDot,
  mobile: faMobile,
  plane: faPlane,
  'paper-plane': faPaperPlane,
  'arrow-down-to-line': faArrowDownToLine,
  trash: faTrashAlt,
  'person-outline': faUser,
  'user-search': faUserMagnifyingGlass,
  phone: faPhone,
  'file-plus': faFilePlus,
  xmark: faXmark,
  // solid
  'solid-circle-exclamation': faCircleExclamation,
  'solid-heart': faHeartSolid,
  'solid-mountains': faMountains,
  'caret-down-solid': faCaretDown,
  'caret-up-solid': faCaretUp,
  'solid-info-circle': faCircleInfoSolid,
  // light
  'light-calendar-check': lightCalendarCheck,
  'light-calendar-day': faCalendarDay,
  'light-clipboard-check': faClipboardCheck,
  'light-shield-check': faShieldCheck,
  'light-parking-circle': faParkingCircle,
  'light-tshirt': faTShirt,
  'light-burger-soda': faBurgerSoda,
  'light-calendar-clock': faCalendarClock,
  'light-info-circle': lightInfoCircle,
  'light-location-dot': lightLocationDot,
  'light-calendar': lightCalendar,
  'light-clock': lightClock,
  'light-star-of-life': faStarOfLife,
  'ligh-scalpel': faScalpel,
  'light-head-side-medical': faHeadSideMedical,
  'light-syringe': faSyringe,
  'light-hospital': faHospital,
  'light-ban': faBan,
  'light-lightbulb-exclamation-on': faLightbulbExclamationOn,
  'light-id-badge': faIdBadge,
  'light-door-open': faDoorOpen,
  'light-window': faWindow,
  'light-house': faHouse,
  'light-phone': lightPhone,
  'light-briefcase-medical': faBriefcaseMedical,
};

export const Icon = (props: IconProps) => {
  const { name, ...iconProps } = props;
  return <InternalIcon {...iconProps} icon={ICON_MAP[name]} />;
};
